<style scoped>

  body, html {
    height: 100%;
    background-color: indianred;
  }

  /*html {*/
  /*background: url(images/bg.jpg) no-repeat center center fixed;*/
  /*-webkit-background-size: cover;*/
  /*-moz-background-size: cover;*/
  /*-o-background-size: cover;*/
  /*background-size: cover;*/
  /*}*/

  .bg {
    height: 100vh;
    /*background-color: dimgray;*/
    background-image: url("../../assets/bglogin.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .container {
    position: absolute;
    top: 45%;
    left: 50%;
    -moz-transform: translateX(-50%) translateY(-55%);
    -webkit-transform: translateX(-50%) translateY(-55%);
    transform: translateX(-50%) translateY(-55%);
    /*border: 1px solid indianred;*/
    padding: 20px;
    opacity: 0.7;
    background-color: #39317e;
    width: 420px;
    height: 370px;
    border-radius: 20px;
  }

  @media only screen and (max-width: 420px) {
    .container {
      width: 100%;
    }
  }

  .shad {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

  .container {
    --color-text-light: #ffffff;
    --color-text: #e6e6e6;
    --color-text-dark: #787bb4;
    --color-input: #2a2f44;
    --color-input-shadow: rgba(255, 255, 255, 0.2);
    --color-neutral-light: #cbcbcb;
  }

  /*div {*/
  /*border: 1px solid indianred;*/
  /*}*/

  a:hover {
    color: azure;
    text-decoration: underline;
  }

  a {
    color: azure;
  }

  .box1 {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    margin-right: 20px;
    padding: 20px;
    border: 1px solid azure;
  }

  .successText {
    color: azure;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>
<template>
  <div class="bg" style="text-align: center;">
    <img alt=""
         src="@/assets/logo.png"
         style="width: 160px; margin-top: 20px;">
    <div v-if="!success" class="container box shad">
      <!--<form @submit.prevent="login">-->
      <div style="color: white; font-size: 20px;">{{ $text.tr('РЕГИСТРАЦИЯ') }}</div>
      <div style="height: 20px;margin-top: 0px; color: indianred; text-align: center;">
        <transition name="fade">
          <span v-if="error">{{ this.errText }}</span>
        </transition>
      </div>
      <i-input v-model="email" type="email" size="large" style="width: 100%; margin-top: 10px;"
             placeholder="email"></i-input><br/>
      <!--<input required v-model="email" type="text" placeholder="email"/><br>-->
      <!--<input required v-model="passwd" type="password" placeholder="пароль"/>-->
      <i-input v-model="passwd" type="password" size="large" style="width: 100%; margin-top: 10px;"
             :placeholder="$text.tr('пароль')"></i-input><br/>
      <i-input v-model="passwd2" type="password" size="large" style="width: 100%; margin-top: 10px;"
             :placeholder="$text.tr('подтверждение пароля')"></i-input><br/><br/><br/>
      <Button size="large" long style="width: 100%;" @click="signup">{{ $text.tr('Зарегистрироваться') }}</Button>
      <!--<button type="submit">Войти</button>-->
      <!--</form>-->
      <div style="margin-top: 15px; ">
        <div
          style="text-align: left; padding-left: 5px; width: 100%; color: azure; font-size: 12px;display:inline-block;">
          <router-link to="/login">{{ $text.tr('Уже зарегистрированы?') }}</router-link>
        </div>
        <!--<div style="text-align: right; margin-right: 15px; width: 150px; color: azure; font-size: 12px;display:inline-block;"></div>-->
      </div>
      <div style="margin-top: 40px; font-size: 12px">
        <p style="color: azure">{{ $text.tr('Регистрируясь, вы соглашаетесь с') }}
          <a :href="termsOfUseLink" target="_blank" style="color: azure">{{ $text.tr('Пользовательским соглашением') }}</a> {{ $text.tr('и') }}
          <a :href="privacyPolicyLink" target="_blank" style="color: azure">{{ $text.tr('Политикой конфиденциальности') }}</a></p>
      </div>
    </div>
    <div v-if="success" class="container box shad successText">
      {{ $text.tr('На ваш email отправлено письмо с ссылкой для подтверждения аккаунта') }}<br><br>
      {{ $text.tr('Если вы не получили письмо, проверьте папку Спам') }}
    </div>
  </div>
</template>

<script>
import { sha256 } from 'js-sha256'
import Api from '@/util/api'
import util from '@/util/util'
export default {
  name: 'Login',
  data: function () {
    return {
      email: '',
      passwd: '',
      passwd2: '',
      error: false,
      errText: '',
      success: false
    }
  },
  computed: {
    termsOfUseLink () {
      if (this.$store.state.sys.lang === 'es' || this.$store.state.sys.lang === 'en') {
        return 'terms_of_use_en.html'
      }
      return 'terms_of_use.html'
    },
    privacyPolicyLink () {
      if (this.$store.state.sys.lang === 'es' || this.$store.state.sys.lang === 'en') {
        return 'privacy_policy_en.html'
      }
      return 'privacy_policy.html'
    }
  },
  methods: {
    showSuccess () {
    },
    signup () {
      if (!this.email.includes('@')) {
        this.error = true
        this.errText = this.$text.tr('Некоректный email')
        setTimeout(() => {
          this.error = false
        }, 3000)
        return
      }

      if (this.passwd.length < 6) {
        this.error = true
        this.errText = this.$text.tr('Пароль минимум 6 символов')
        setTimeout(() => {
          this.error = false
        }, 3000)
        return
      }

      if (this.passwd !== this.passwd2) {
        this.error = true
        this.errText = this.$text.tr('Пароли не совпадают')
        setTimeout(() => {
          this.error = false
        }, 3000)
        return
      }
      // var tok = sha256(this.email + this.passwd)
      // console.log(tok)
      let rlid = localStorage.getItem('rlid')
      if (!rlid) {
        rlid = ''
      }

      let href = localStorage.getItem('capico_href')
      if (!href) {
        href = ''
      }
      href = encodeURIComponent(href)

      const x = sha256('V1c5QraZkYkA1' + this.email.trim().toLowerCase()).substr(0, 6)
      Api
        .get('signup?email=' + this.email.trim().toLowerCase() + '&pwdh=' + sha256(this.passwd) + '&rlid=' + rlid +
        '&lang=' + this.$store.state.sys.lang + '&x=' + x + '&href=' + href)
        .then(response => {
          // console.log(response.data)
          if (response.data.err !== undefined) {
            this.$Message.error(this.$text.tr('Ошибка') + ': ' + util.returnTextForErr(response.data.err))
          } else {
            this.success = true
            // this.$Message.success('Успешная регистрация')

            // this.$store.state.token = tok
            // localStorage.setItem('token', tok)
            // this.$store.state.email = response.data.Email
            // this.$store.state.exchanges = response.data.exchanges
            // this.$router.push('/')
          }
        })
        .catch(error => {
          console.log(error.response)
          // console.log(error)
          // this.error = true
          // setTimeout(() => {
          //   this.error = false
          // }, 3000)
        })
        /*
        if (this.email === '1' && this.passwd === '1') {
          this.error = false

          // this.$store.state.token = ''
          // localStorage.setItem('token')
          this.$router.push('/')
        } else {
          var tok = sha256(this.email + this.passwd)
        }
        */
    }
  }
}
</script>
